import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-3"
}
const _hoisted_2 = {
  key: 1,
  class: "text-base text-gray-500"
}

import type { DoctorDetailCompanyLink } from '@/Network/Types/Responses/CompanyResponses'
import DetailCard from '../atoms/DetailCard.vue'
import CompanyInviteRow from '../atoms/CompanyInviteRow.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyInvitesPanel',
  props: {
    companies: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DetailCard, { title: "Vínculos por empresa" }, {
    default: _withCtx(() => [
      (_ctx.companies.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (link) => {
              return (_openBlock(), _createBlock(CompanyInviteRow, {
                key: link.companyDoctorId,
                link: link
              }, null, 8, ["link"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_2, "Nenhum vínculo com empresa."))
    ]),
    _: 1
  }))
}
}

})